<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      cell-class-name="align-top"
      resizable
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displaySalesTitle="{ row }">
        <span style="color: #303133">{{ row.salesTitle }}</span>
        <br />
        <span>SKU：</span><span style="color: #409EFF">{{ row.hxGoodsSkuNo }}</span>
        <br />
        <span>ITEM：</span
        ><span style="color: #409EFF">{{ row.channelItemNo }}</span>
        <br />
        <span>CHSKU：</span
        ><span style="color: #409EFF">{{ row.channelSkuNo }}</span>
        <br />
        <span>EANNo：</span
        ><span style="color: #409EFF">{{ row.channelEanNo }}</span>
      </template>
      <template v-slot:displayPlatform="{ row }">
        <span>PLATFORM：</span
        ><span style="color: #303133">{{ row.platformName }}</span>
        <br />
        <span>BRAND：</span
        ><span style="color: #303133">{{ row.brandName }}</span>
        <br />
        <div>
          <span>METHOD：</span>
          <el-tag
            v-if="row.v_hxSellType"
            size="mini"
            :type="
              row.hxSellType === 'B'
                ? ''
                : row.hxSellType === 'C'
                ? 'warning'
                : 'success'
            "
          >
            {{ row.v_hxSellType || '未配置' }}
          </el-tag>
        </div>
        <div>
          <span>STATUS：</span>
          <el-tag
            size="mini"
            :type="
              row.hxSkuPlatformStatus === 'Y'
                ? 'success'
                : row.hxSkuPlatformStatus === 'S'
                ? 'warning'
                : ''
            "
          >
            {{ row.v_hxSkuPlatformStatus || '未配置状态' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
}
</script>
